import request from '@/utils/request'

/**
 * 获取公司方案列表
 * @param param
 */
export function fetchData(userId) {
  return request({
    url: '/api/scheme/company/list/' + userId,
    method: 'get',
  })
}

/**
 * 获取公司方案列表
 * @param param
 */
export function get(id) {
  return request({
    url: '/api/scheme/get/' + id,
    method: 'get',
  })
}


/**
 * 查询我的方案个数
 * @param param
 */
export function getSchemeList(type, id) {
  return request({
    url: '/api/scheme/project/list/' + type + "/" + id,
    method: 'post'
  })
}

/**
 * 查询我的套餐剩余
 * @param param
 */
export function getSchemeSurplus(companyId) {
  return request({
    url: `/api/scheme/surplus/${companyId}`,
    method: 'post'
  })
}

/**
 * 查询我的方案统计
 * @param param
 */
export function getSchemeCount(companyId) {
  return request({
    url: `/api/scheme/count/${companyId}`,
    method: 'post'
  })
}

/**
 * 查询胜任力方案详情
 * @param param
 */
export function getFencScheme() {
  return request({
    url: `/api/scheme/fenc/simple`,
    method: 'post'
  })
}
/**
 * 查询胜任力方案详情
 * @param param
 */
export function getFencManageScheme() {
  return request({
    url: `/api/scheme/fenc/manage`,
    method: 'post'
  })
}



